import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';

import Typography from '../../../components/atoms/Typography';
import Box from '../../../components/molecules/Box';
import Grid from '../../../components/molecules/Grid';
import ButtonMUI from '../../../components/atoms/Button';
import Picture from '../../../components/atoms/Picture';
import useStyles from './style';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { pushAnaylyticsData } from '../../../../utils/analytics';
import aspectRatios from '../../../utils/AspectRatios';
import { createDynamicLabels } from '../../../../../src/utils/analytics';
import RichText from '../../../components/atoms/RichText';

const PanelDetails = props => {
  const { fields, readMoreText, pageName, componentName, stopTitle } = props;

  const classes = useStyles();
  const {
    location,
    timing,
    description,
    link,
    name,
  } = fields || {};
  let { frontImage } = fields || {};
  const readMore = get(link, 'value.text', '') || readMoreText;

  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.readMoreBtnClick,
      ...{ label: createDynamicLabels([pageName, componentName, name && name.value]) },
    };
    pushAnaylyticsData(obj);
  };

  if (!get(frontImage, 'value.src', '')) {
    frontImage = {
      value: {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=',
        '3x2': {
          large: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAADklEQVR42mNkAANGCAUAACMAA2w/AMgAAAAASUVORK5CYII=',
        },
      },
    }
  }

  return fields ? (
    <>
      <Box className={classes.imageSection}>
        <Grid container className={classes.frontImage}>
          <Grid item>
            <Picture
              media={{
                image: frontImage,
                aspectRatio: aspectRatios['3x2'],
              }}
              alternateAltText={stopTitle}
            />
          </Grid>
        </Grid>
      </Box>
      {
        stopTitle &&
        <Typography
          component="p"
          variant="h3"
          display="block"
          className={classes.title}
        >
          <Text field={{ value: stopTitle }} />
        </Typography>
      }
      {location && location.value && (
        <Typography
          variant="body2"
          component="p"
          className={classes.regionField}
        >
          <Text field={location} />
        </Typography>
      )}
      {
        timing &&
        <Typography component="p" variant="body1" className={classes.timing}>
          <Text field={timing} />
        </Typography>
      }
      {description && description.value && (
        <Typography
          component="p"
          variant="body1"
          className={classes.description}
        >
          <RichText
            innerHTML={description}
          />
        </Typography>
      )}
      {readMore && (
        <ButtonMUI
          component="span"
          buttonType="secondary"
          hasBorder={false}
          isStartIcon={true}
          size="small"
          field={link}
          onClick={addAnalyticsInfo}
        >
          <Typography component="span" variant="body2Bold">
            <Text field={{ value: readMore }} />
          </Typography>
        </ButtonMUI>
      )}
    </>
  ) : null;
};

export default PanelDetails;
